import { isLocalFont } from './isLocalFont';
/**
 * Collects all the font combinations based on the typography configurations
 * that are defined in the theme.
 *
 * For example, when there is a font configuration with the font family "MyFont" with
 * a font weight of "Bold", it will add the expected "MyFontBold" font file to to the
 * array.
 */
export const collectFontCombinations = (themePartial, fonts = []) => {
    Object.values(themePartial).forEach((themePartialChild) => {
        if (typeof themePartialChild === 'object') {
            const { fontFamily, fontWeight, fontStyle } = themePartialChild;
            /**
             * If the current theme partial object contains the `fontFamily` it must
             * be a typography configuration.
             */
            if (fontFamily) {
                let fileName = `${fontFamily}${fontWeight}${fontStyle || ''}`.replace(/ /g, '');
                if (isLocalFont(fontFamily)) {
                    fileName = fontFamily;
                }
                const hasFont = fonts.find((font) => font.fileName === fileName);
                if (hasFont)
                    return;
                fonts.push(Object.assign({ fileName, family: fontFamily, weight: fontWeight }, (fontStyle && { style: fontStyle })));
            }
            else {
                collectFontCombinations(themePartialChild, fonts);
            }
        }
    });
    return fonts;
};
//# sourceMappingURL=collectFontCombinations.js.map